import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Laura', 'Roberto', 'Ana', 'Sofía', 'Diego', 'Valentina', 'Mateo', 'Isabella', 'Lucía', 'Santiago', 'Camila', 'Sebastián', 'Elena'];
const CITIES = ['Buenos Aires', 'Madrid', 'Bogotá', 'Ciudad de México', 'Barcelona', 'Lima', 'Santiago', 'Medellín', 'Valencia', 'Córdoba', 'Rosario', 'Guadalajara', 'Cali', 'Sevilla', 'Montevideo'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNewNotification();
    }, 5000);
    // Periodic notifications
    const interval = setInterval(() => {
      showNewNotification();
    }, 20000 + Math.random() * 10000); // Random interval between 20-30s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showNewNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-slide-in-up max-w-xs w-full" data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg p-4 border-l-4 border-teal-500 flex items-start gap-3" data-id="element-2">
        <div className="bg-teal-100 rounded-full p-2 flex-shrink-0" data-id="element-3">
          <CheckCircle className="w-5 h-5 text-teal-600" data-id="element-4" />
        </div>
        <div data-id="element-5">
          <p className="text-sm font-medium text-gray-900" data-id="element-6">
            ¡Nueva compra verificada!
          </p>
          <p className="text-sm text-gray-600 mt-1" data-id="element-7">
            <span className="font-semibold" data-id="element-8">{data.name}</span> de {data.city}{' '}
            acaba de comprar este libro digital.
          </p>
          <p className="text-xs text-gray-400 mt-2" data-id="element-9">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}